import { ref, onMounted, onBeforeUnmount } from '@vue/composition-api'
import { on, off } from '@/util'
import { throttle, debounce } from 'lodash-es'

export const useOnScroll = (el) => {
  const scrollLeft = ref(0)
  const scrollTop = ref(0)

  const onScroll = throttle((e) => {
    scrollLeft.value = e.target.scrollLeft
    scrollTop.value = e.target.scrollTop
  }, 16)
  const onMouseOver = debounce((e) => {
    on(el.value, 'scroll', onScroll)
  }, 300)
  const onMouseOut = debounce((e) => {
    off(el.value, 'scroll', onScroll)
  }, 300)
  onMounted(() => {
    if (el.value) {
      on(el.value, 'mouseover', onMouseOver)
      on(el.value, 'mouseout', onMouseOut)
    }
  })
  onBeforeUnmount(() => {
    if (el.value) {
      off(el.value, 'mouseover', onMouseOver)
      off(el.value, 'mouseout', onMouseOut)
      off(el.value, 'scroll', onScroll)
    }
  })
  // 暴露出去
  return {
    scrollLeft,
    scrollTop
  }
}
